import { Http } from '@gamiphy/http';
import { Discount } from '@gamiphy/bl/reward';

export type CreateDiscountsResponse = {
  discount: Discount,
}
export type UpdateDiscountsResponse = {
  discount: Discount,
}
export type GetDiscountsResponse = {
  discounts: Discount[],
  count: number
}

export class DiscountsApi {
  public static async createDiscount(discount: Omit<Discount, 'id' | 'app' | 'createdAt'>): Promise<Discount> {
    const response = await Http.post<CreateDiscountsResponse>({
      url: '/v2/discounts',
      payload: discount,
    });

    return response.data.discount;
  }

  public static async update(discountId: string, discount: Partial<Omit<Discount, 'id' | 'app' | 'createdAt'>>): Promise<Discount> {
    const response = await Http.patch<UpdateDiscountsResponse>({
      url: `/v2/discounts/${discountId}`,
      payload: discount,
    });

    return response.data.discount;
  }

  public static async getDiscounts(): Promise<Discount[]> {
    const response = await Http.get<GetDiscountsResponse>({
      url: '/v2/discounts',
    });

    return response.data.discounts;
  }
}
